<script lang="ts" setup>
import BrandReviewCard from '~/components/cards/BrandReviewCard.vue'
import JsonApiHelper from '~/helpers/json-api-helper'
import type { BrandProductReview } from '~/types/reviews'

const props = defineProps<{
  brandId: string
}>()

const messages = {
  failedToGetReviews: 'Не удалось получить отзывы.',
  noReviews: 'Нет отзывов.'
}

const swiperOptions = {
  observer: true,
  breakpoints: {
    0: { slidesPerView: 1.15, spaceBetween: 16 },
    768: { slidesPerView: 2, spaceBetween: 24 }
  }
}

const { $apiHelper, $toast } = useNuxtApp()

const { data: reviewsData, status: reviewsStatus } = await useLazyAsyncData('reviewsDataKey', loadReviewsData)

async function loadReviewsData (): Promise<BrandProductReview[]> {
  const params = { 'filter[brandId]': props.brandId, 'page[size]': 8 }

  try {
    const response = await $apiHelper.reviews.getReviews(params) as any
    const { data } = JsonApiHelper.denormalizeResponse(response) as any

    return data
  } catch (error) {
    console.error(error)

    $toast.error(messages.failedToGetReviews)

    throw error
  }
}
</script>

<template>
  <div class="brand-reviews">
    <div class="h2">
      Отзывы
    </div>

    <Preloader v-if="reviewsStatus === 'pending'" />
    <template v-else-if="reviewsStatus === 'success' && reviewsData">
      <Gallery v-if="reviewsData.length" :options="swiperOptions">
        <div
          v-for="x in reviewsData"
          :key="x.id"
          class="swiper-slide max-2-slides flex h-auto cursor-pointer items-stretch justify-center"
        >
          <BrandReviewCard :review-data="x" />
        </div>
      </Gallery>
      <Notification v-else status="info">
        {{ messages.noReviews }}
      </Notification>
    </template>
    <template v-else>
      <Notification class="mb-4" status="error">
        {{ messages.failedToGetReviews }}
      </Notification>

      <a href="#" @click.prevent="refreshNuxtData('reviewsDataKey')">Повторить попытку</a>
    </template>
  </div>
</template>

<style lang="scss">
.brand-reviews {
  .swiper-container {
    padding: 0 !important;
  }

  .swiper-button-prev {
    left: -20px !important;
  }

  .swiper-button-next {
    right: -20px !important;
  }
}
</style>

<style lang="scss" scoped>
@use 'assets/css/gallery';

.swiper-wrapper {
  align-items: stretch;
}
</style>
